import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Row, ///Container,
  Col, CardBody
} from 'reactstrap';
import { Link } from 'react-router-dom'
import DataLoader from '../../app/DataLoader';
import StepData from './StepData';
import StepDataRegular from './StepData-RegularUsers';
// import Progress from './Progress';
import checkIcon from '../../img/get-started/check.png';
import { hasLoggedIn } from '../../redux/actions/userActions';
import $ from 'jquery';
class GetStarted extends Component {

  state = {
    active: 0,
    stepData: StepData[0],
    stepDataRegular: StepDataRegular[0]
  }
  selectStep(step, data) {
    this.setState({
      active: step,
      stepData: data,
      stepDataRegular: data
    })
  }

  componentDidMount() {
    this.props.hasLoggedIn(this.props.user)

  }


  render() {

    if (this.props.user['cognito:groups'] == undefined || this.props.user['cognito:groups'].find(e => {
      return e.includes('Admin') ||
        e.includes('Manager')
    }) == undefined) {
      return (
        <DataLoader>
          <div className='get-started'>
            <Row className='progress-heading'>
              <h1 style={{ color: '#487D8A' }}>Getting Started</h1>
              <h4 className='left-element page-title left-side'>Posture is a platform that allows organizations to quickly and painlessly build and maintain a HIPAA Compliance Program while continuously strengthening privacy and security awareness.</h4>
              <h4 className='left-element page-title left-side'>As part of your role with your company, you are required to receive Cybersecurity and HIPAA Awareness training. This training and the corresponding quizzes are on the Posture platform.
              Don't worry, the training videos and quizzes are short and sweet. You should make it through without falling asleep.</h4>
            </Row>
            <Row>
              <Col className="left-side">
                <div className=' card project-summary__statistics'>
                  <CardBody>
                    {/* <h5 className='project-summary__statistic-title'>Get Started With Posture, Now</h5> */}
                    {StepDataRegular.map((step, i) => (
                      <Row key={i} className={`step-container${i === this.state.active ? ' active' : ' inactive'}`}
                        onClick={() => {
                          $(".more-info.card-body").animate({
                            scrollTop: '+=10px'
                          });
                          this.selectStep(i, step)
                        }}>
                        <div className="overlay-effect"></div>
                        <img
                          src={i === this.state.active ? step.colorIcon : step.defaultIcon}
                          alt='step-icon' />
                        <div style={{ float: 'right' }} className="body">
                          <p className="page-title">{i + 1}. {step.title}</p>
                          <p>{step.desc}</p>
                        </div>
                        <div className="icon-container">
                          <img src={checkIcon} alt="check icon" id="checkIcon" />
                        </div>
                      </Row>
                    ))}</CardBody>
                </div>

              </Col>
              <Col className="right-side">
                <div className=' card project-summary__statistics'>
                  <CardBody className="more-info">
                    <h5 className='project-summary__statistic-title'>More Information</h5>
                    {this.state.stepDataRegular.body}


                    {this.state.stepDataRegular.show === false ? null :
                      this.state.stepDataRegular.download === true ?
                        <a href={this.state.stepDataRegular.url}>{this.state.stepDataRegular.title}</a> :
                        !this.state.stepDataRegular.access ||
                          (this.state.stepDataRegular.access &&
                            this.props.user &&
                            this.props.user['cognito:groups'] &&
                            this.props.user['cognito:groups'].find(e => {
                              return e === this.state.stepDataRegular.access.level
                            })) ?
                          <Link
                            to={this.state.stepDataRegular.url}
                            id={this.state.stepDataRegular.id}>
                            {this.state.stepDataRegular.title}
                          </Link>
                          : <p>{this.state.stepDataRegular.access.msg}</p>
                    }

                    {this.state.stepDataRegular.gif ? <img src={this.state.stepDataRegular.gif} alt="GIF" /> : null}
                  </CardBody>
                </div>
              </Col>
            </Row>
          </div>
        </DataLoader >
      )
    }
    else {
      return (
        <DataLoader>
          <div className='get-started'>
            <Row className='progress-heading'>
              <h3 className='left-element page-title left-side'>Getting Started with HIPAA</h3>
              {/* <Progress completed={3} className="right-side"/> */}
            </Row>
            <Row>
              <Col className="left-side">
                <div className=' card project-summary__statistics'>
                  <CardBody>
                    {/* <h5 className='project-summary__statistic-title'>Get Started With Posture, Now</h5> */}
                    {StepData.map((step, i) => (
                      <Row key={i} className={`step-container${i === this.state.active ? ' active' : ' inactive'}`}
                        onClick={() => {
                          $(".more-info.card-body").animate({
                            scrollTop: '+=10px'
                          });
                          this.selectStep(i, step)
                        }}>
                        <div className="overlay-effect"></div>
                        <img
                          src={i === this.state.active ? step.colorIcon : step.defaultIcon}
                          alt='step-icon' />
                        <div style={{ float: 'right' }} className="body">
                          <p className="page-title">{i + 1}. {step.title}</p>
                          <p>{step.desc}</p>
                        </div>
                        <div className="icon-container">
                          <img src={checkIcon} alt="check icon" id="checkIcon" />
                        </div>
                      </Row>
                    ))}</CardBody>
                </div>

              </Col>
              <Col className="right-side">
                <div className=' card project-summary__statistics'>
                  <CardBody className="more-info">
                    <h5 className='project-summary__statistic-title'>More Information</h5>
                    <p>{this.state.stepData.body}</p>

                    {this.state.stepData.download === true ?
                      <a href={this.state.stepData.url}>{this.state.stepData.title}</a> :

                      !this.state.stepData.access ||
                        (this.state.stepData.access &&
                          this.props.user &&
                          this.props.user['cognito:groups'] &&
                          this.props.user['cognito:groups'].find(e => {
                            return e === this.state.stepData.access.level
                          })) ?
                        <Link
                          to={this.state.stepData.url}
                          id={this.state.stepData.id}>
                          {this.state.stepData.title}
                        </Link> : <p>{this.state.stepData.access.msg}</p>
                    }
                    {this.state.stepData.gif ? <img src={this.state.stepData.gif} alt="GIF" /> : null}
                  </CardBody>
                </div>
              </Col>
            </Row>
          </div>
        </DataLoader >
      )
    }
  }
}



function mapStateToProps(state) {
  return {
    user: state.auth.user,
    sidebar: state.sidebar
  }
}

export default connect(mapStateToProps, { hasLoggedIn })(GetStarted);


// WEBPACK FOOTER //
// ./src/components/get-started/GetStarted.js